import { Module } from 'wrapper6'
const $ = jQuery

export default class Accordion extends Module {
  ready (app) {
    const ACCORDIONS = document.querySelectorAll('.mtt-accordion__accordion-title')
    if (ACCORDIONS.length > 0) {
      for (let i = 0; i < ACCORDIONS.length; i++) {
        let ACCORDION = ACCORDIONS[i]
        ACCORDION.addEventListener('click', () => {
          ACCORDION = $(ACCORDION)
          ACCORDION.parent().toggleClass('active')
          ACCORDION.parent().find('.mtt-accordion__accordion-content').slideToggle()
        })
      }
    }
  }
}
